import { FC, Fragment } from "react";
import { LinkedObjectChip } from "./LinkedObjectChip";
import { hasChips, parseChips } from "./parse-chips";

interface ChippyTextProps {
  text: string;
  inline?: boolean;
  // Optional fallback rendering for the all-text path so callers can keep
  // their own placeholder/empty-state appearance.
  emptyFallback?: React.ReactNode;
}

// Plain-text + inline chip renderer. Use anywhere the existing rendering
// just stuffs a string into a div/span (table cells, kv values, task labels).
// Markdown bodies should use the markdown-link rewrite path instead so that
// MemCommonMarkdown's parser keeps working end-to-end.
export const ChippyText: FC<ChippyTextProps> = ({ text, inline = true, emptyFallback }) => {
  if (text.length === 0) {
    return <>{emptyFallback ?? null}</>;
  }
  if (!hasChips(text)) {
    return <>{text}</>;
  }
  const segments = parseChips(text);
  return (
    <>
      {segments.map((segment, index) => {
        if (segment.type === "text") {
          return <Fragment key={index}>{segment.value}</Fragment>;
        }
        return <LinkedObjectChip key={index} chip={segment.chip} inline={inline} />;
      })}
    </>
  );
};
